import React, { useRef, useEffect, useState, lazy, Suspense, useCallback } from 'react';
import { listObjectsInBucket } from '../S3/s3';
//import { configureAWS, getS3Instance } from '../S3/s3'; //Old implementation
import AWS from 'aws-sdk';
// import "../../styles.css";
//import './styles.css';
import './Main.module.css';
import Preview from '../Preview/Preview';
import ModelViewer from '../ModelViewer/ModelViewer';
import ProductViewerComponent from '../Preview/React360Viewer';
import InnerImageZoom from '../InnerImageZoom/InnerImageZoom';
import { Spinner } from 'spin.js';
import './spin.css';

// const Preview = lazy(() => import('../Preview/Preview'));
// const ModelViewer = lazy(() => import('../ModelViewer/ModelViewer'));
// const ProductViewerComponent = lazy(() => import('../Preview/React360Viewer'));
// const InnerImageZoom = lazy(() => import('../InnerImageZoom/InnerImageZoom'));

const PointOfView = {
  Front: 'front',
  Left: 'left',
  Back: 'back',
  Right: 'right',
}

const SelectedViewer = {
  ThreeSixty: 'ThreeSixtyViewer',
  ThreeD: 'ModelViewer',
  TwoD: 'Lifestyle',
}

const ObjectType = {
  Image: 'image',
  ModelGlb: 'modelGlb',
  ModelGlbU: 'modelGlbU',
  ModelUsd: 'modelUsd',
  ModelHdr: 'modelHdr',
  EnvironmentHdr: 'environmentHdr',
}

const productImageTemplate = {
  image: null,
  thumbnail: null,
}

const cameraTransform = {
  location: null,
  rotation: null,
}

// Temporary FPS Counter Component
// const FPSCounter = () => {
//   const [fps, setFps] = useState(0);
//   const [isThrottled, setIsThrottled] = useState(false);
//   const framesRef = useRef(0);
//   const lastTimeRef = useRef(performance.now());
//   const frameTimesRef = useRef([]);
//   const isVisibleRef = useRef(true);

//   useEffect(() => {
//     let animationFrameId;
//     let lastFrameTime = performance.now();

//     // Track visibility to detect background throttling
//     const handleVisibilityChange = () => {
//       isVisibleRef.current = !document.hidden;
//     };
//     document.addEventListener('visibilitychange', handleVisibilityChange);

//     const measureFPS = (currentTime) => {
//       // Calculate time since last frame
//       const deltaTime = currentTime - lastFrameTime;
//       lastFrameTime = currentTime;

//       // Track frame times for throttling detection
//       frameTimesRef.current.push(deltaTime);
//       if (frameTimesRef.current.length > 60) {
//         frameTimesRef.current.shift();
//       }

//       framesRef.current += 1;
//       const elapsed = currentTime - lastTimeRef.current;

//       // Update FPS every second
//       if (elapsed >= 1000) {
//         const calculatedFps = Math.round((framesRef.current * 1000) / elapsed);
//         setFps(calculatedFps);

//         // Detect throttling: if most frames are ~33ms apart (30fps) instead of ~16ms (60fps)
//         const avgFrameTime = frameTimesRef.current.reduce((a, b) => a + b, 0) / frameTimesRef.current.length;
//         const isLikelyThrottled = calculatedFps <= 31 && avgFrameTime > 30 && avgFrameTime < 35;
//         setIsThrottled(isLikelyThrottled && isVisibleRef.current);

//         framesRef.current = 0;
//         lastTimeRef.current = currentTime;
//         frameTimesRef.current = [];
//       }

//       animationFrameId = requestAnimationFrame(measureFPS);
//     };

//     animationFrameId = requestAnimationFrame(measureFPS);

//     return () => {
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//       if (animationFrameId) {
//         cancelAnimationFrame(animationFrameId);
//       }
//     };
//   }, []);

//   return (
//     <div
//       style={{
//         position: 'fixed',
//         top: '10px',
//         right: '10px',
//         backgroundColor: isThrottled ? 'rgba(200, 50, 50, 0.8)' : 'rgba(0, 0, 0, 0.7)',
//         color: 'white',
//         padding: '8px 12px',
//         borderRadius: '4px',
//         fontFamily: 'monospace',
//         fontSize: '14px',
//         zIndex: 10000,
//         pointerEvents: 'none',
//         userSelect: 'none',
//       }}
//     >
//       <div>FPS: {fps}</div>
//       {isThrottled && (
//         <div style={{ fontSize: '10px', color: '#ffcccc', marginTop: '2px' }}>
//           (Throttled)
//         </div>
//       )}
//       {document.hidden && (
//         <div style={{ fontSize: '10px', color: '#ffcccc', marginTop: '2px' }}>
//           (Background)
//         </div>
//       )}
//     </div>
//   );
// };

/**
 * Extract the numeric index from an image filename
 * Supports patterns like: Object_9.jpg, Object_9_full.jpg, or 6_full-scaled.jpg
 * Returns the number before .jpg or before _full
 */
const extractImageIndex = (filename, debug = false) => {
  if (!filename) return 0;
  
  // Remove path if present, get just the filename
  const lastSlashIndex = filename.lastIndexOf('/');
  const name = lastSlashIndex >= 0 ? filename.substring(lastSlashIndex + 1) : filename;
  
  let result = 0;
  
  // Handle full HD images (e.g., Object_9_full.jpg or 6_full-scaled.jpg)
  // Match numbers that come before _full
  if (name.includes('_full')) {
    const match = name.match(/(\d+)_full/);
    result = match ? parseInt(match[1], 10) : 0;
  } else {
    // Handle standard images (e.g., Object_9.jpg)
    const match = name.match(/(\d+)(?=\.jpg|\.jpeg|\.png|\.gif)/i);
    result = match ? parseInt(match[1], 10) : 0;
  }
  
  // Debug logging only when enabled
  if (debug) {
    console.log(`extractImageIndex: filename="${filename}", name="${name}", result=${result}`);
  }
  
  return result;
};

/**
 * Sort an array of image URLs by their numeric index
 * Ensures images are in the correct order (1, 2, 3, ...)
 */
const sortImagesByIndex = (imageArray, debugName = '') => {
  if (!Array.isArray(imageArray) || imageArray.length === 0) {
    return imageArray;
  }
  
  const shouldDebug = false; //debugName.includes('HD'); // Only debug HD images for now
  
  // Log first 3 items before sorting
  if (shouldDebug && imageArray.length > 0) {
    console.log(`${debugName} - Unsorted array (first 3):`);
    imageArray.slice(0, 3).forEach((url, idx) => {
      const extractedIdx = extractImageIndex(url, false);
      console.log(`  [${idx}]: index=${extractedIdx}, url=${url}`);
    });
  }
  
  const sorted = [...imageArray].sort((a, b) => {
    const indexA = extractImageIndex(a, shouldDebug);
    const indexB = extractImageIndex(b, shouldDebug);
    
    return indexA - indexB;
  });
  
  if (shouldDebug && sorted.length > 0) {
    console.log(`${debugName} - Sorted result (first 10):`);
    sorted.slice(0, 10).forEach((url, idx) => {
      console.log(`  [${idx}]: index=${extractImageIndex(url)}, url=${url}`);
    });
  }
  
  return sorted;
};

const Main = (props) => {
  const { productFolder, productVariants, productS3BucketUrl, cloudFrontUrl, showAdditionalButtons } = props;
  const [currentIdx, setCurrentIdx] = useState(0);
  const [modelviewerSelected, setModelviewerSelected] = useState(SelectedViewer.ThreeSixty);
  const modelviewerSelectedRef = useRef(modelviewerSelected);
  // Update ref when state changes
  useEffect(() => {
    modelviewerSelectedRef.current = modelviewerSelected;
  }, [modelviewerSelected]);
  const [modelViewerInitialised, setModelViewerInitialised] = useState(true);
  const [isAutoPlay, setIsAutoplay] = useState(true);
  const [imageToShow, setImageToShow] = useState(0);
  const [toggleImage, setToggleImage] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [picToShow, setPicToShow] = useState(null);
  const [images360, setImages360] = useState([]);
  const [images360HD, setImages360HD] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [modelGlb, setModelGlb] = useState();
  //Uncompressed Glb model
  const [modelGlbU, setModelGlbU] = useState();
  const [modelUsd, setModelUsd] = useState();
  const [modelHdrs, setModelHdrs] = useState();
  const [environmentHdrs, setEnvironmentHdrs] = useState();
  const initializeProductSettings = () => {
    try {
      if (typeof props.productSettings === 'string') {
        // Avoid parsing "[object Object]" string explicitly
        if (props.productSettings === '[object Object]') {
          console.warn('Received "[object Object]" string for productSettings, defaulting to empty object.');
          return {};
        }
        // Ensure there's a string to parse, default to '{}' if props.productSettings is null, undefined, or empty
        return JSON.parse(props.productSettings || '{}');
      } else if (typeof props.productSettings === 'object' && props.productSettings !== null) {
        console.log('Main.js - product settings from props:', props.productSettings);
        return props.productSettings; // It's already an object
      }
    } catch (error) {
      console.error("Error parsing props.productSettings:", error);
    }
    // Default to an empty object if type is unexpected or parsing fails
    return {};
  };
  const [productSettings, setProductSettings] = useState(initializeProductSettings());
  //Do we need to initialise dimensionsJson?
  const [yawAngle, setYawAngle] = useState(25);
  const [pitchAngle, setPitchAngle] = useState(60);
  const initializeAssetsUrls = () => {
    try {
      if (typeof props.assetsUrls === 'string') {
        // Avoid parsing "[object Object]" string explicitly
        if (props.assetsUrls === '[object Object]') {
          console.warn('Received "[object Object]" string for assetsUrls, defaulting to empty object.');
          return {};
        }
        return JSON.parse(props.assetsUrls || '{}'); // Use empty object string as default if null/undefined
      } else if (typeof props.assetsUrls === 'object' && props.assetsUrls !== null) {
        console.log('Main.js - Assets URLs from props:', props.assetsUrls);
        return props.assetsUrls; // It's already an object
      }
    } catch (error) {
      console.error("Error parsing props.assetsUrls:", error);
    }
    // Default to an empty object if type is unexpected or parsing fails
    return {};
  };
  const [assetsUrls, setAssetsUrls] = useState(initializeAssetsUrls());
  
  // Update assetsUrls when props.assetsUrls changes
  useEffect(() => {
    const newAssetsUrls = initializeAssetsUrls();
    setAssetsUrls(newAssetsUrls);
  }, [props.assetsUrls]);
  
  const [objectDimensions, setObjectDimensions] = useState();
  const [isFilesLoaded, setIsFilesLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isButtonsReady, setIsButtonsReady] = useState(false);
  const [didLoadFromAssetsUrls, setDidLoadFromAssetsUrls] = useState(false); // Flag to track loading path
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  //TODO: Swap fixed values for parameters
  const [buttonsDivSize, setButtonsDivSize] = useState(Math.min((window.innerWidth - 40), 1000) / 1000 * 200);
  const [calculatedButtonsDivSize, setCalculatedButtonsDivSize] = useState(props.productSettings?.additionalButtonsMaxSize ?
    props.productSettings.additionalButtonsMaxSize : (images360.length > 0 && productImages.length > 0) ? 200 : 0);
  const [aspectRatio360, setAspectRatio360] = useState(1);
  const [aspectRatioProduct, setAspectRatioProduct] = useState(1);
  const [aspectRatioTop, setAspectRatioTop] = useState(1);
  const [isShow360SpinIcon, setIsShow360SpinIcon] = useState(false);
  //Get a ref to out mainProductViewer container so we can set the width of children based on its width
  const mainProductViewerRef = useRef(null);
  //We need to set those values on instantiation
  const [mainProductViewerWidth, setMainProductViewerWidth] = useState(0);
  const [mainProductViewerHeight, setMainProductViewerHeight] = useState(0);
  const [camTransform, setCamTransform] = useState({ ...cameraTransform });
  const triggerAREvent = useRef(null);
  const [isAspectRatio360Calculated, setIsAspectRatio360Calculated] = useState(false);
  const [isAspectRatioTopCalculated, setIsAspectRatioTopCalculated] = useState(false);
  const [isAspectRatioProductCalculated, setIsAspectRatioProductCalculated] = useState(false);
  const [is360Present, setIs360Present] = useState(false);
  const [isTopPresent, setIsTopPresent] = useState(false);
  const [isProductPresent, setIsProductPresent] = useState(false);
  const [viewerMode, setViewerMode] = useState(props.productSettings?.startViewerMode || '360');
  const [isModelViewerLoaded, setIsModelViewerLoaded] = useState(false);
  const [viewpointImages, setViewpointImages] = useState({
    [PointOfView.Front]: "",
    [PointOfView.Left]: "",
    [PointOfView.Back]: "",
    [PointOfView.Right]: "",
  });
  const [productScreenshots, setProductScreenshots] = useState([]);
  const [windowMargin, setWindowMargin] = useState(10);
  const [viewerMarginLeft, setViewerMarginLeft] = useState(0);
  const [viewerContainerMarginLeft, setViewerContainerMarginLeft] = useState(0);
  const [viewerContainerMarginRight, setViewerContainerMarginRight] = useState(0);
  const [viewerContainerMarginBottom, setViewerContainerMarginBottom] = useState(0);
  const [viewerMarginRight, setViewerMarginRight] = useState(0);
  const [viewerMarginBottom, setViewerMarginBottom] = useState(0);
  const [widthSwitchToFullScreen, setWidthSwitchToFullScreen] = useState(980);
  const [maxViewerWidth, setMaxViewerWidth] = useState(1100);
  const mobileWidthThreshold = 540;
  const [variantDataMap, setVariantDataMap] = useState(new Map());
  const [viewerSize, setViewerSize] = useState({ width: 0, height: 0 });
  //const s3Ref = useRef(new AWS.S3());
  const spinnerContainerRef = useRef(null); // Create a reference for the spinner container
  const spinnerInstanceRef = useRef(null); // Store the Spinner instance
  const dataRef = useRef(null);
  const imagesBaseUrl = `https://${props.productsS3Bucketname}.s3.eu-west-2.amazonaws.com/${props.productFolder}/`;
  const bucketName = props.productS3BucketUrl;
  const prefix = props.productFolder;
  const baseCloudFrontUrl = props.cloudFrontUrl;
  const buttonHeightSpace = 180;
  const viewerBtnShrinkRatio = 0.8;
  const additionalButtonsMaxSize = 200;
  const timeBeforeShowingSpinIcon = 2500;


  const handleScreenshotsReady = useCallback((screenshots) => {
    console.log('Screenshots ready:', screenshots);
    setProductScreenshots(screenshots);

    // Each screenshot object has: { angle, dataURL, blob }
  }, []);

  //TODO: Parse whole directory and extract model and images
  // const customerFiles = Array.from(props.productS3BucketUrl);
  //const model = customerFiles.filter(item => item.Key.match(/\.(glb\gltf)$/i)).map(item => item.Key);
  //const fileExtension = model.name.split('.')[1];

  // Helper function to generate URLs
  const getUrlForKey = (key) => `${baseCloudFrontUrl}/${key}`;

  const handlePrev = () => {
    setCurrentIdx((prevIdx) => (prevIdx - 1 + props.previewItems.length) % props.previewItems.length);
  };

  const handleNext = () => {
    setCurrentIdx((prevIdx) => (prevIdx + 1) % props.previewItems.length);
  };

  const handlePreviewClick = (index) => {
    setCurrentIdx(index);
  };

  const switchViewer = (newViewer) => {
    console.log('switchViewer, modelviewerSelected: ' + modelviewerSelectedRef.current + ', newViewer: ' + newViewer);
    setModelViewerInitialised(true);

    // Update ref immediately to prevent timing issues
    const actualViewer = (!productSettings.pure3D || newViewer === SelectedViewer.TwoD) ? newViewer : SelectedViewer.ThreeD;
    modelviewerSelectedRef.current = actualViewer;
    setModelviewerSelected(actualViewer);

    if (newViewer === SelectedViewer.ThreeD) {
      setYawAngle(productSettings.startCamYawAngle || 25);
      setPitchAngle(productSettings.startCamPitchAngle || 60);
      setViewerMode('3D');
      setIsModelViewerLoaded(true);
    } else if (newViewer === SelectedViewer.ThreeSixty) {
      setPitchAngle(80);
      setViewerMode('360');
    }
  };

  useEffect(() => {
    console.log('modelviewerSelected changed to: ' + modelviewerSelected);
    console.log('isModelViewerLoaded:', isModelViewerLoaded);
  }, [modelviewerSelected, isModelViewerLoaded]);

  //Commented out temporarily to hide 360 icon
  // useEffect(() => {
  //   if (modelviewerSelected === SelectedViewer.ThreeSixty && !isShow360SpinIcon) {
  //     setTimeout(() => {
  //       setIsShow360SpinIcon(true)
  //     }, timeBeforeShowingSpinIcon);
  //   }
  // }, [modelviewerSelected])

  const changePicToShow = (image) => {
    //Set viewer to a specific image and set autoplay to false
    setPicToShow(image);
    switchViewer(SelectedViewer.TwoD);
  }

  const change360View = (pointOfView) => {
    //Set viewer to a specific image and set autoplay to false
    //Need tags on images or convention that it's always 36 images and we use image 0, 9, 18 and 27
    //Need a top view
    console.log('change360View: ' + pointOfView);
    setIsAutoplay(false);
    console.log('POV:', pointOfView);
    switch (pointOfView) {
      case PointOfView.Front:
      default:
        setImageToShow(productSettings.is180Pan ? Math.round(productSettings.react360ImagesCount / 2) : 0); // Front view is half-way through the pan for a 180 pan
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Right:
        setImageToShow(productSettings.is180Pan ? 0 : productSettings.react360ImagesCount / 4);
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Back:
        setImageToShow(productSettings.react360ImagesCount / 2);
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Left:
        setImageToShow(productSettings.is180Pan ? productSettings.react360ImagesCount - 1 : 3 * productSettings.react360ImagesCount / 4);
        setToggleImage((prev) => !prev);
        break;

    }

    switchViewer(SelectedViewer.ThreeSixty);
  };

  useEffect(() => {
    //Need to force update when we click on the same point of view twice in a row
    //Run it in useEffect to avoid out of sync rendering issues
    setForceUpdate((prev) => !prev);
  }, [toggleImage])

  const changeCamView = (pointOfView) => {
    //Set viewer to a specific image and set autoplay to false
    //Need tags on images or convention that it's always 36 images and we use image 0, 9, 18 and 27
    //Why do I have to add 30 degrees to the yaw angle?
    //Need a top view
    console.log('changeCamView: ' + pointOfView);
    switch (pointOfView) {
      case PointOfView.Front:
      default:
        setYawAngle(0);
        setPitchAngle(90);
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Left:
        setYawAngle(90);
        setPitchAngle(90);
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Back:
        setYawAngle(180);
        setPitchAngle(90);
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Right:
        setYawAngle(270);
        setPitchAngle(90);
        setToggleImage((prev) => !prev);
        break;
    }
    switchViewer(SelectedViewer.ThreeSixty);
  };

  const handleZoomClick = (clickedImageIndex) => {
    setIsAutoplay(false);
    // clickedImageIndex is the 0-based index passed from React360Viewer
    console.log("Clicked image index (0-based):", clickedImageIndex);
    setImageToShow(clickedImageIndex);
  }

  const getViewPointImg = async (viewPoint, valueToGet) => {
    const newValue = await valueToGet;
    return { viewPoint, newValue };
  };

  const handleResize = () => {
    //Commenting this out might break something
    // document.body.style.display = "none";
    // requestAnimationFrame(() => {
    //   document.body.style.display = "";
    //   const width = window.innerWidth;
    //   setWindowWidth(width);
    // })
    // Only update width if not touching
    if (!isTouching) {
      const width = window.innerWidth;
      setWindowWidth(width);
    }
  };

  //TODO: Call this function from the S3 branch
  const calculateAspectRatios = async ({ image360, productImage, topImage }) => {
    console.log('Main.js: Image for 360 ratio:', image360);
    console.log('Main.js: Image for product ratio:', productImage);
    console.log('Main.js: Image for top ratio:', topImage);
    // Calculate 360 aspect ratio
    if (image360) {
      const img = new Image();
      img.src = image360;
      console.log('360 image:', img);
      await new Promise(resolve => {
        img.onload = () => {
          console.log('360 image loaded:', img);
          console.log('360 image natural width:', img.naturalWidth);
          console.log('360 image natural height:', img.naturalHeight);
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          setAspectRatio360(width / height);
          setIs360Present(true);
          resolve();
        };
        img.onerror = () => {
          console.warn('Failed to load 360 image for aspect ratio calculation');
          resolve();
        };
      });
    }
    setIsAspectRatio360Calculated(true);

    // Calculate product aspect ratio from first non-top product image
    if (productImage) {
      const img = new Image();
      img.src = productImage;
      console.log('Product image:', img);
      await new Promise(resolve => {
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          setAspectRatioProduct(width / height);
          setIsProductPresent(true);
          resolve();
        };
        img.onerror = () => {
          console.warn('Failed to load product image for aspect ratio calculation');
          resolve();
        };
      });
    }
    setIsAspectRatioProductCalculated(true);

    // Calculate top view aspect ratio
    if (topImage) {
      const img = new Image();
      img.src = topImage;
      console.log('Top image:', img);
      await new Promise(resolve => {
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          setAspectRatioTop(width / height);
          resolve();
        };
        img.onerror = () => {
          console.warn('Failed to load top image for aspect ratio calculation');
          resolve();
        };
      });
      setIsTopPresent(true);
    }
    setIsAspectRatioTopCalculated(true);
  };


  const getSignedUrl = async (productFolder, objectType, objectToFind = PointOfView.Front) => {
    //const currentData = await s3Ref.current.listObjectsV2(s3Params).promise();

    //const baseCloudFrontUrl = `https://${props.productS3BucketUrl}/${props.productFolder}/`;

    try {
      const currentData = await listObjectsInBucket(bucketName, productFolder);

      let cloudFrontUrls = [];

      if (objectType === ObjectType.Image) {

        const tempImg = currentData.Contents
          .filter(item => item.Key.match(new RegExp(`${objectToFind}\.(jpg|jpeg|png|gif|webp)$`, 'i')) &&
            !item.Key.match(/_env\.(jpg)$/i))
          .map(item => item.Key);
        console.log("Processing image:", tempImg);
        return tempImg.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelGlb) {
        //Ignore _uncompressed here
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/\.(glb|gltf)$/i) && !item.Key.match(/_uncompressed\.(glb|gltf)$/i))
          .map(item => item.Key);
        console.log("Glb model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelGlbU) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/_uncompressed\.(glb|gltf)$/i))
          .map(item => item.Key);
        console.log("GlbU model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelUsd) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/\.(usd|usdz)$/i))
          .map(item => item.Key);
        console.log("Usd model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelHdr) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/\.(hdr)$/i) && !item.Key.match(/_env\.(hdr)$/i))
          .map(item => item.Key);
        console.log("Hdr model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.EnvironmentHdr) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/_env\.(hdr|exr|jpg)$/i))
          .map(item => item.Key);
        console.log("Hdr environment:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      return cloudFrontUrls;
    } catch (error) {
      console.error("Error listing S3 objects: ", error);
      return [];
    }
  }


  const fetchFiles = async (productFolder) => {
    // const params = {
    //   Bucket: props.productS3BucketUrl,
    //   Prefix: productFolder
    // };


    const currentData = await listObjectsInBucket(bucketName, productFolder);
    //const currentData = await s3Ref.current.listObjectsV2(params).promise();
    //const response = await fetch(`https://s3.eu-west-2.amazonaws.com/${params.Bucket}?prefix=${params.Prefix}`);
    //const currentData = await response.json();

    console.log("Searching through:", productFolder);

    const imageKeys360HD = currentData.Contents
      .filter(item => {
        const regex = new RegExp(`${productFolder}/\\d+_full+\\.(jpg|jpeg|png|gif|webp)$`, 'i');
        return regex.test(item.Key);
      })
      .sort((a, b) => {
        const numA = parseInt(a.Key.split('/')[1].split('_')[0], 10);
        const numB = parseInt(b.Key.split('/')[1].split('_')[0], 10);
        return numA - numB;
      })
      .map(item => item.Key);

    //If no full images are found, try to find standard images
    const imageKeys360 = currentData.Contents
      .filter(item => {
        const regex = new RegExp(`${productFolder}/\\d+\\.(jpg|jpeg|png|gif|webp)$`, 'i');
        return regex.test(item.Key);
      })
      .sort((a, b) => {
        const numA = parseInt(a.Key.split('/')[1].split('_')[0], 10);
        const numB = parseInt(b.Key.split('/')[1].split('_')[0], 10);
        return numA - numB;
      })
      .map(item => item.Key);

    const images360Urls = imageKeys360.map(item => getUrlForKey(item));
    const images360HDUrls = imageKeys360HD.map(item => getUrlForKey(item));

    console.log('images360Urls length:', images360Urls.length);
    console.log('images360HDUrls length:', images360HDUrls.length);

    let imageFor360Ratio;
    let imageForProductRatio;
    let imageForTopRatio;

    // We don't get anything processed here
    if (images360Urls && images360Urls.length > 0) {
      imageFor360Ratio = images360Urls[0];
    }

    // Create a regex pattern to match files we want to exclude, i.e. we only want files that have letters and don't include _front, _right, etc.
    const exclusionPattern = new RegExp(`(_(${Object.values(PointOfView).join('|')}))\\.(jpg|jpeg|png|gif|webp)$`, 'i');
    const inclusionPattern = /\.(jpg|jpeg|png|gif|webp)$/i;
    const numberPattern = /\/\d+\.(jpg|jpeg|png|gif|webp)$/i;
    const numberFullRes = '_full';

    //console.log('currentData contents 2:', currentData);

    const imageKeys = currentData.Contents
      .filter(item =>
        !item.Key.match(exclusionPattern) &&
        item.Key.match(inclusionPattern) &&
        !item.Key.match(numberPattern) &&
        !item.Key.match(numberFullRes)
      )
      .map(item => item.Key);

    //console.log("image keys:", imageKeys);

    const productImagesMap = new Map();
    const fileExtensions = ['.jpg', 'jpeg', '.png', '.gif', '.webp'];

    //We go through this 3 times, why? Twice makes sense, once for the sku, once for the variants
    imageKeys.forEach(async (url) => {

      const isThumbnail = url.includes('_thumbnail');
      //This is failing
      const extension = fileExtensions.find(ext => url.endsWith(ext));

      if (!extension) {
        return;
      }

      //Get the root name of the image
      const baseName = isThumbnail ?
        url.replace(`_thumbnail${extension}`, '') :
        url.replace(extension, '');

      if (!productImagesMap.has(baseName)) {
        productImagesMap.set(baseName, { ...productImageTemplate });
      }
      //Get #_high pictures and put them in an array

      const productImage = productImagesMap.get(baseName);
      console.log('Image:', productImage);

      let isRatioProductSet = false;

      if (isThumbnail) {
        productImage.thumbnail = getUrlForKey(url);
      }
      else {
        productImage.image = getUrlForKey(url);
        if (!isRatioProductSet && !productImage.image.includes('_top.jpg')) {
          imageForProductRatio = productImage.image;
          //TODO: Rename variables and simplify if needed
          isRatioProductSet = true;
        }
        else {
          const topImage = productImage.image.includes('_top.jpg') ? productImage.image : null;
          imageForTopRatio = topImage;
          if (topImage) {
            setIsTopPresent(true);
          }
        }
      }

    });

    const productImages = Array.from(productImagesMap.values());
    console.log('productImages:', productImages);

    const modelGlb = await getSignedUrl(productFolder, ObjectType.ModelGlb);
    const modelGlbU = await getSignedUrl(productFolder, ObjectType.ModelGlbU);
    const modelUsd = await getSignedUrl(productFolder, ObjectType.ModelUsd);
    const modelHdrs = await getSignedUrl(productFolder, ObjectType.ModelHdr);
    const environmentHdrs = await getSignedUrl(productFolder, ObjectType.EnvironmentHdr);
    const picToShow = await getSignedUrl(productFolder, ObjectType.Image, PointOfView.Front);

    //Recover json file here and parse json into a string to pass it on to ModelViewer as uniqueProductSettings
    const jsonConfigFile = currentData.Contents.find((item) => item.Key.endsWith('config.json'));
    const jsonDimensionsFile = currentData.Contents.find((item) => item.Key.endsWith('dimensions.json'));

    const s3 = new AWS.S3();
    let productSettings = JSON.parse(props.productSettings);

    const getJsonStringFromBucket = async (jsonFile) => {
      const params = {
        Bucket: bucketName,
        Key: jsonFile.Key,
      };
      const jsonFileData = await s3.getObject(params).promise();

      const jsonString = jsonFileData.Body.toString('utf-8');
      return JSON.parse(jsonString);
    }

    if (jsonConfigFile) {
      const modelViewerConfig = await getJsonStringFromBucket(jsonConfigFile);
      if (productSettings){
        const mergedConfig = {
          ...productSettings, // Base settings
          ...modelViewerConfig // Overrides from viewerConfig
        };
        productSettings = mergedConfig;
      }
    }

    //TODO: Make sure we get this when we pass the json manually
    if (jsonDimensionsFile) {
      const modelDimensions = await getJsonStringFromBucket(jsonDimensionsFile);

      setObjectDimensions(modelDimensions);
      console.log('model dimensions:', modelDimensions);

    }

    console.log('image 360:', images360Urls);
    console.log('image 360 HD:', images360HDUrls);
    console.log('product images:', productImages);
    //Getting promise here and not what we want
    console.log('modelGlb:', modelGlb);
    console.log('modelGlb uncompressed:', modelGlbU);
    console.log('modelUsd:', modelUsd);
    console.log('modelHdrs:', modelHdrs);
    console.log('environmentHdrs:', environmentHdrs);
    console.log('picToShow:', picToShow);
    console.log('aspect ratios:', aspectRatio360, aspectRatioTop, aspectRatioProduct);

    return {
      images360: images360Urls,
      images360HD: images360HDUrls,
      imageFor360Ratio,
      imageForProductRatio,
      imageForTopRatio,
      //aspectRatio360,
      productImages,
      //aspectRatioProduct,
      //aspectRatioTop,
      modelGlb,
      modelGlbU,
      modelUsd,
      modelHdrs: modelHdrs,
      environmentHdrs: environmentHdrs,
      picToShow,
      productSettings,
    };
  }

  const fetchAllFiles = async () => {
    //Get data from currentData
    //Pb: It looks like variantDataMap is empty as it re-renders
    const currentData = variantDataMap.has(productFolder) ? variantDataMap.get(productFolder) : null;
    console.log("Main.js: Current data:", currentData);

    if (currentData) {
      return variantDataMap;
    }

    // Fetch base SKU data first and set it immediately
    const baseSkuData = await fetchFiles(props.productFolder);
    console.log("Main.js: Base SKU data loaded:", props.productFolder);

    // Create new variant data map and set base SKU data
    const newVariantDataMap = new Map();
    newVariantDataMap.set(props.productFolder, baseSkuData);

    // Handle variants in the background
    if (productVariants && productVariants.length > 0) {
      // Create a Set to track processed SKUs
      const processedSkus = new Set([props.productFolder]);

      // Filter out duplicate SKUs and already processed variants
      const uniqueVariants = productVariants.filter(item => {
        const skuName = item.sku ? item.sku : item;

        // Skip if SKU has already been processed
        if (skuName === "" || processedSkus.has(skuName)) {
          console.log(`Main.js: Skipping duplicate SKU: ${skuName}`);
          return false;
        }

        // Mark SKU as processed
        processedSkus.add(skuName);
        return true;
      });

      // Fetch variant data in the background
      const variantDataPromises = uniqueVariants.map(item =>
        fetchFiles(item.sku ? item.sku : item)
          .then(data => {
            console.log(`Main.js: Variant data loaded: ${item.sku || item}`);
            const skuName = item.sku ? item.sku : item;
            newVariantDataMap.set(skuName, data);
            return data;
          })
          .catch(error => {
            console.error(`Main.js: Error fetching variant ${item.sku || item}:`, error);
          })
      );

      // Don't wait for variant data to complete
      Promise.all(variantDataPromises).catch(error => {
        console.error('Main.js: Error fetching variants:', error);
      });

      // Update the state with the new map
      console.log('Main.js: Setting variant data map:', newVariantDataMap);
      setVariantDataMap(newVariantDataMap);
    }

    //When we change the drop-down selection, the whole component re-renders and re-import assets. That's not happening on localhost though.
    //Might be because we set setLoading to true
    //setIsFilesLoaded(true);
    //Force model viewer reinitialisation after loading product settings
    setModelViewerInitialised(false);

    // Return the map immediately with base SKU data
    return newVariantDataMap;
  };


  const setTriggerAR = (triggerFn) => {
    triggerAREvent.current = triggerFn;
    console.log('trigger function:', triggerFn);
  };

  const triggerAR = () => {
    if (triggerAREvent.current) {
      console.log('main trigger ar');
      triggerAREvent.current();
    }
    else {
      console.error('triggerAR is not defined in Carousel');
    }
  }

  const changeViewerMode = (newViewerMode) => {
    //setViewerMode(newViewerMode);
    //if (newViewerMode === "360") 
    switchViewer(newViewerMode === "360" ? SelectedViewer.ThreeSixty : SelectedViewer.ThreeD);
  }

  useEffect(() => {
    // Don't switch model viewer after first load
    if (modelViewerInitialised) return;

    // Get the product settings after parsing the JSON
    const settings = productSettings;
    let shortlistedKeys = [];
    console.log('my model glb:', modelGlb);

    // Helper: normalize string/array check
    //Check if array[0] is empty as well
    const hasNonEmptyValue = (val) => {
      if (Array.isArray(val)) return (val.length > 0 && val[0] !== "");
      if (typeof val === "string") return val.trim() !== "";
      return false;
    };

    // Make sure we've got assets for the selected viewer
    if (settings["ModelViewer"] >= 0 && hasNonEmptyValue(modelGlb)) {
      shortlistedKeys.push("ModelViewer");
    }

    if (
      settings["ThreeSixtyViewer"] >= 0 &&
      ((productSettings.pure3D && hasNonEmptyValue(modelGlb)) ||
        (!productSettings.pure3D && hasNonEmptyValue(images360)))
    ) {
      shortlistedKeys.push("ThreeSixtyViewer");
    }

    if (settings["Lifestyle"] >= 0 && hasNonEmptyValue(productImages)) {
      shortlistedKeys.push("Lifestyle");
    }

    let selectedKey = null;
    // Select the key with the lowest value
    const lowestValueKey = shortlistedKeys.reduce((acc, key) => {
      return (settings[key] < settings[acc]) ? key : acc;
    }, shortlistedKeys[0]); // Start with the first key as the "lowest" by default

    selectedKey = lowestValueKey;
    if (shortlistedKeys.length == 0 || !selectedKey) {
      //Show placeholder image and no buttons
      setModelviewerSelected(SelectedViewer.TwoD);
      const placeholderPicture = `${window.ASSET_BASE_URL || process.env.PUBLIC_URL}/image-placeholder.webp`
      setPicToShow(placeholderPicture);
      setModelViewerInitialised(true);
      return;
    }

    //Need a check here to prevent from switching if we've set this up previously
    // Update the selected viewer based on the selected key
    switch (selectedKey) {
      case 'ModelViewer':
        setModelviewerSelected(SelectedViewer.ThreeD);
        setIsModelViewerLoaded(true);
        setViewerMode('3D');
        break;
      case 'ThreeSixtyViewer':
        if (!productSettings.pure3D) {
          setModelviewerSelected(SelectedViewer.ThreeSixty);
        }
        else {
          setModelviewerSelected(SelectedViewer.ThreeD);
          setIsModelViewerLoaded(true);
        }
        setViewerMode('360');
        break;
      case 'Lifestyle':
        setModelviewerSelected(SelectedViewer.TwoD);
        setPicToShow(productImages[0].image);
        break;
      default:
        if (!productSettings.pure3D) {
          setModelviewerSelected(SelectedViewer.ThreeSixty); // Fallback if no match is found
        }
        else {
          setModelviewerSelected(SelectedViewer.ThreeD);
          setIsModelViewerLoaded(true);
        }
        setViewerMode('360');
    }
    setModelViewerInitialised(true);
  }, [modelViewerInitialised]);

  useEffect(() => {
    //This doesn't make much sense. Check if it's still needed
    // const areAssetUrlsValid = assetsUrls && typeof assetsUrls === 'object' && Object.keys(assetsUrls).length > 0;
    // if (areAssetUrlsValid) return;

    let resizeTimeout;

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize)
    return () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [isFilesLoaded]);


  // Add touch interaction state
  const [isTouching, setIsTouching] = useState(false);

  useEffect(() => {
    const rootElement = document.getElementById(props.rootDiv);
    if (!rootElement) return;

    // Debounced resize observer to prevent too frequent updates
    let timeoutId;
    const debouncedUpdate = (entries) => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        // Only update if not touching
        if (!isTouching) {
          for (let entry of entries) {
            const { width, height } = entry.contentRect;
            console.log('SETTING VIEWER SIZE:', width, height);
            setViewerSize({ width, height });
          }
        }
      }, 100); // 100ms debounce
    };

    const resizeObserver = new ResizeObserver(debouncedUpdate);
    resizeObserver.observe(rootElement);

    return () => {
      resizeObserver.disconnect();
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [props.rootDiv, isTouching]);

  // Add touch event handlers
  useEffect(() => {
    const handleTouchStart = () => setIsTouching(true);
    const handleTouchEnd = () => setIsTouching(false);

    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchend', handleTouchEnd, { passive: true });
    window.addEventListener('touchcancel', handleTouchEnd, { passive: true });

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
      window.removeEventListener('touchcancel', handleTouchEnd);
    };
  }, []);

  useEffect(() => {
    console.log('Selected viewer:', modelviewerSelected);
  }, [modelviewerSelected]);

  // Helper function to apply product settings
  const applyProductSettings = (settingsData) => {
    const settings = typeof settingsData === 'string' ? JSON.parse(settingsData || '{}') : (settingsData || {});
    console.log('start pitch angle:', settings.startCamPitchAngle, 'yaw angle:', settings.startCamYawAngle);
    setYawAngle(settings.startCamYawAngle || 15);
    setPitchAngle(settings.startCamPitchAngle || 75);
    setWindowMargin(settings.windowMargin !== undefined ? settings.windowMargin : 10);
    setViewerMarginLeft(settings.viewerMarginLeft !== undefined ? settings.viewerMarginLeft : 0);
    setViewerMarginRight(settings.viewerMarginRight !== undefined ? settings.viewerMarginRight : 0);
    setViewerMarginBottom(settings.viewerMarginBottom !== undefined ? settings.viewerMarginBottom : 0);
    setViewerContainerMarginLeft(settings.viewerContainerMarginLeft !== undefined ? settings.viewerContainerMarginLeft : 0);
    setViewerContainerMarginRight(settings.viewerContainerMarginRight !== undefined ? settings.viewerContainerMarginRight : 0);
    setViewerContainerMarginBottom(settings.viewerContainerMarginBottom !== undefined ? settings.viewerContainerMarginBottom : 0);
    setWidthSwitchToFullScreen(settings.switchToFullScreen !== undefined ? settings.switchToFullScreen : 980);
    setMaxViewerWidth(settings.maxViewerWidth !== undefined ? settings.maxViewerWidth : 1100);
    // Note: We don't set the main productSettings state here to avoid potential loops if it were a dependency
  };

  // Function to load assets from assetsUrls
  const loadFromAssetsUrls = async () => {
    //TODO: Update to parse assetsUrls as an array optionally => find assets automatically
    console.log('Main.js: Loading assets directly from assetsUrls state:', assetsUrls);
    setDidLoadFromAssetsUrls(true);

    // Set model assets
    setModelGlb([assetsUrls.modelGlb || '']);
    setModelGlbU(assetsUrls.modelGlbU || '');
    setModelUsd(assetsUrls.modelUsd || '');
    setModelHdrs(assetsUrls.modelHdrs || '');
    setEnvironmentHdrs(assetsUrls.environmentHdrs || '');

    // Set image assets - sort to ensure correct order
    setImages360(sortImagesByIndex(assetsUrls.imagesSpin || [], 'images360'));
    setImages360HD(sortImagesByIndex(assetsUrls.imagesSpinFull || [], 'images360HD'));

    //TODO: Implement this when S3 branch is done
    // const productImagesMap = new Map();
    // assetsUrls.productImages.forEach(async (url) => {
    // const fileExtensions = ['.jpg', 'jpeg', '.png', '.gif'];
    // const extension = fileExtensions.find(ext => url.endsWith(ext));

    // const baseName = url.replace(`_thumbnail${extension}`, '');

    //   if (!productImagesMap.has(baseName)) {
    //     productImagesMap.set(baseName, { ...productImageTemplate });

    //     const productImages = Array.from(productImagesMap.values());

    setProductImages(assetsUrls.productImages ? assetsUrls.productImages.map(url => ({ image: url, signedUrl: url })) : []);
    if (modelViewerInitialised && modelviewerSelected === SelectedViewer.TwoD && picToShow && picToShow.includes('_top.jpg')) {
      setPicToShow(assetsUrls.productImages.find(imgObj => imgObj.image.includes('_top.jpg')).image);
    }
    else {
      setPicToShow(assetsUrls.productImages?.[0] || null);
    }

    // Map viewpoint images
    //If the viewpoint images aren't called thumbnail_, this won't work. TODO: fix
    const newViewpointImages = {};
    if (assetsUrls.imagesSpinThumb?.length) {
      assetsUrls.imagesSpinThumb.forEach(url => {
        // Extract the filename from the URL
        const filename = url.split('/').pop().toLowerCase();
        console.log('Main.js: Processing viewpoint image:', filename);

        // Create a mapping of viewpoint names to their enum values
        const viewpointMap = {
          'thumbnail_front': PointOfView.Front,
          'thumbnail_left': PointOfView.Left,
          'thumbnail_back': PointOfView.Back,
          'thumbnail_right': PointOfView.Right,
          'thumbnail_top': PointOfView.Top
        };

        // Find the exact match for the filename without extension
        const filenameWithoutExt = filename.split('.')[0];
        if (viewpointMap[filenameWithoutExt]) {
          newViewpointImages[viewpointMap[filenameWithoutExt]] = url;
        }
      });
    }
    console.log('Main.js: Received viewpoint images:', newViewpointImages);
    setViewpointImages(newViewpointImages);

    if (!modelViewerInitialised) {
      // Calculate aspect ratios
      await calculateAspectRatios({
        image360: assetsUrls.imagesSpin?.[0] || null,
        productImage: assetsUrls.productImages?.[0] || null,
        topImage: assetsUrls.productImages?.find(img => img?.includes('_top')) || null
      });
    }

    let configData = {};
    
    if (assetsUrls.configJson) {
      try {
        const response = await fetch(assetsUrls.configJson);
        configData = await response.json();
        console.log('Main.js: Received config:', configData);
        if (productSettings){
          const productSettings = JSON.parse(props.productSettings);
          console.log('Main.js: Initial product settings from props:', productSettings);
          setProductSettings({ ...productSettings, ...configData });
        }
        else {
          setProductSettings(configData);
        }
      } catch (error) {
        console.error('Main.js: Error fetching config:', error);
      }
    }

    const jsonString = props.dimensionsJson;
    const isEmptyJson = !jsonString || jsonString === "" || jsonString === "{}" || (typeof jsonString === "object" && Object.keys(jsonString).length === 0);
    
    console.log('Main.js: dimensionsJson prop:', jsonString, 'isEmptyJson:', isEmptyJson);

    console.log('dimensions check:', productSettings.simpleDimensions, productSettings.advancedDimensions);

    if ((assetsUrls.configJson && configData && (configData.simpleDimensions || configData.advancedDimensions)) || 
    (productSettings.simpleDimensions || productSettings.advancedDimensions)) {
      if (!isEmptyJson) {
        //const dimensionsData = JSON.parse(jsonString);
        console.log('Main.js: Received dimensions from props:', jsonString);
        setObjectDimensions(jsonString);
      }
      else if (assetsUrls.dimensionsJson) {
        try {
          const response = await fetch(assetsUrls.dimensionsJson);
          const dimensionsData = await response.json();
          console.log('Main.js: Received dimensions:', dimensionsData);
          setObjectDimensions(dimensionsData);
        } catch (error) {
          console.error('Main.js: Error fetching dimensions:', error);
        }
      }
    }

    // Mark loading as complete
    setIsAspectRatio360Calculated(true);
    setIsAspectRatioTopCalculated(true);
    setIsAspectRatioProductCalculated(true);
    setIsFilesLoaded(true);
    setModelViewerInitialised(false);
    console.log('Main.js: Finished loading assets from assetsUrls.');
  };

  // Function to load assets from S3
  const loadFromS3 = async () => {
    console.log('Main.js: Loading assets from S3...');
    setDidLoadFromAssetsUrls(false);

    if (!props.productS3BucketUrl || !props.productFolder || !props.cloudFrontUrl) {
      console.warn('Main.js: Missing S3 props for fetching.');
      return;
    }

    try {
      await fetchAllFiles();
    } catch (error) {
      console.error('Main.js: Error during S3 fetchAllFiles:', error);
      throw error; // Propagate error to be handled by the main error handler
    }
  };

  // Main useEffect for asset loading
  useEffect(() => {
    console.log('Main.js: Assets URLs changed:', assetsUrls);
    console.log('Main.js: Product folder changed:', productFolder);
    console.log('Main.js: Product S3 bucket URL changed:', productS3BucketUrl);
    console.log('Main.js: CloudFront URL changed:', cloudFrontUrl);

    const loadAssets = async () => {

      setLoading(true);
      setIsFilesLoaded(false);

      try {
        // Determine which loading path to take
        const areAssetUrlsValid = assetsUrls && typeof assetsUrls === 'object' && Object.keys(assetsUrls).length > 0;

        console.log('Main.js: Are asset URLs valid?', areAssetUrlsValid);

        if (areAssetUrlsValid) {
          await loadFromAssetsUrls();
        } else {
          // Fetch all files and update the map
          const newMap = await fetchAllFiles();
          console.log('Main.js: New map:', newMap);
          setVariantDataMap(newMap);

          // Set loading states after map is updated
          setIsFilesLoaded(true);
          setLoading(false);
        }
      } catch (error) {
        console.error('Main.js: Error during loadAssets:', error);
      }
    };

    loadAssets();
  }, [assetsUrls, productFolder, productS3BucketUrl, cloudFrontUrl]);

  useEffect(() => {
    console.log('Main.js: Variant data map changed:', variantDataMap);
  }, [variantDataMap]);

  useEffect(() => {
    console.log('Main.js: Product settings changed:', productSettings);
  }, [productSettings]);

  useEffect(() => {
    if (!assetsUrls || typeof assetsUrls !== 'object' || !Object.keys(assetsUrls).length) return;
    applyProductSettings(productSettings);
    console.log('Main.js: Applied product settings (using assetsUrls path).');
  }, [productSettings, assetsUrls, applyProductSettings]);

  useEffect(() => {
    // Run only after files are loaded AND if loading happened via S3 (not assetsUrls) AND not currently loading
    if (didLoadFromAssetsUrls || loading) return;

    //We don't want to use the default productFolder
    console.log('Main.js: Applying data loaded from S3 via variantDataMap for folder:', productFolder);
    //variantDataMap.get(productFolder)
    const currentData = variantDataMap.get(productFolder);
    console.log('Main.js: S3 Current Data:', currentData);

    if (!currentData) {
      console.warn('Main.js: No data found in variantDataMap for S3 path:', productFolder);
      return; // Exit if no data for current S3 folder
    }

    // Apply Settings from S3 data
    if (currentData.productSettings) {
      // Only update state if the fetched settings are different from current state?
      // Consider potential loops if setProductSettings triggers the primary effect again.
      // For now, we assume applyProductSettings helper doesn't cause issues.
      applyProductSettings(currentData.productSettings); // Apply settings using helper
      // If you need the state to reflect the *fetched* settings for other logic,
      // uncomment the next line carefully:
      setProductSettings(currentData.productSettings);
      console.log('Main.js: Applied product settings from S3 data.');
    } else {
      console.log('Main.js: No productSettings found in S3 data.');
      // Apply default settings if needed (e.g., from initial state or empty)
      applyProductSettings(initializeProductSettings()); // Re-apply initial/default settings
    }

    // Set Assets from S3 data - sort images to ensure correct order
    setImages360(sortImagesByIndex(currentData.images360 || [], 'images360-S3'));
    setImages360HD(sortImagesByIndex(currentData.images360HD || [], 'images360HD-S3'));
    setProductImages(currentData.productImages || []);
    //Set model glb as string to test it out
    setModelGlb(currentData.modelGlb || '');
    setModelGlbU(currentData.modelGlbU || '');
    setModelUsd(currentData.modelUsd || '');
    setModelHdrs(currentData.modelHdrs || '');
    setEnvironmentHdrs(currentData.environmentHdrs || '');

    // Handle viewpoint images from S3 data
    const fetchAndViewpointImages = async () => {
      try {
        const points = [PointOfView.Front, PointOfView.Left, PointOfView.Back, PointOfView.Right, PointOfView.Top];
        // Use getSignedUrl safely, assuming it handles potential errors or missing files
        const urlPromises = points.map(p => getSignedUrl(props.productFolder, ObjectType.Image, p).catch(err => {
          console.warn(`Failed to get signed URL for ${p}:`, err);
          return null; // Return null on error for specific viewpoint
        }));
        const urls = await Promise.all(urlPromises);

        const newViewpoints = {};
        points.forEach((p, index) => {
          if (urls[index]) { // Check if URL was successfully obtained
            newViewpoints[p] = urls[index];
          }
        });
        setViewpointImages(newViewpoints);
        console.log('Main.js: Fetched viewpoint images for S3 path.');
      } catch (error) {
        console.error("Main.js: Error fetching viewpoint images for S3 path:", error);
        setViewpointImages({}); // Set empty on error
      }
    };
    fetchAndViewpointImages();

    // Set picToShow after productImages are set
    const initialPic = currentData.picToShow && currentData.picToShow[0]
      ? currentData.picToShow[0]
      : (currentData.productImages && currentData.productImages[0] ? currentData.productImages[0].image : null);

    if (modelViewerInitialised && modelviewerSelected === SelectedViewer.TwoD) {
      if (picToShow && picToShow.includes('_top.jpg')) {
        setPicToShow(currentData.productImages.find(imgObj => imgObj.image.includes('_top.jpg')).image);
      }
      else {
        setPicToShow(currentData.productImages?.[0].image || null);
      }
    }
    else {
      setPicToShow(initialPic);
    }
    console.log('Main.js: Pic to show (S3 path) initialPic:', initialPic);

    //Set Aspect Ratios from S3 data
    const setAspectRatios = async () => {
      try {
        await calculateAspectRatios({
          image360: currentData.imageFor360Ratio,
          productImage: currentData.imageForProductRatio,
          topImage: currentData.imageForTopRatio
        });

        setIsAspectRatio360Calculated(true);
        setIsAspectRatioTopCalculated(true);
        setIsAspectRatioProductCalculated(true);
        console.log('Main.js: Aspect ratios calculated successfully.');
      } catch (error) {
        //We're getting an error here
        console.error('Main.js: Error calculating aspect ratios:', error);
        // Set default values in case of error
        setAspectRatio360(1);
        setAspectRatioTop(1);
        setAspectRatioProduct(1);
        setIsAspectRatio360Calculated(true);
        setIsAspectRatioTopCalculated(true);
        setIsAspectRatioProductCalculated(true);
      }
    };

    if (!modelViewerInitialised) {
      setAspectRatios();
    }

    console.log('Main.js: Finished applying S3 data.');
    setIsFilesLoaded(true);
    //setModelViewerInitialised(true);

  }, [isFilesLoaded, didLoadFromAssetsUrls, variantDataMap, productFolder, loading]); // Depends on loading completion, path flag, map updates, folder, and loading state


  //Call that each time mainProductViewerRef updates
  useEffect(() => {
    // Function to update the mainProductViewer's dimensions
    const element = mainProductViewerRef.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      // Only update if not touching
      if (!isTouching) {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setMainProductViewerWidth(width);
          setMainProductViewerHeight(height);
          console.log('Resized to:', width, height);
        }
      }
    });

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };

  }, [window.innerWidth, mainProductViewerRef.current, isTouching]);

  //Pb: this is called twice: once when we change productImages and once again when we change viewpointImages
  //Need to trigger Preview to re-render when viewpointImages is updated
  //TODO: Have viewpoint images when we haven't got the full 360 renders, but just the thumbnails
  //If we don't have that, we need to default to 3d mode (ok already)
  useEffect(() => {
    //This works fine the first time round, but then we need to clear viewpointImages when we update props.productFolder
    if ((images360.length > 0 && viewpointImages[PointOfView.Right] != "") || (productImages.length > 0 && images360.length == 0)
      || productSettings.pure3D && productScreenshots.length > 0) {
      setIsButtonsReady(true);
      console.log('viewpointimages:', viewpointImages);
      console.log('product images:', productImages);
    }
  }, [images360, productImages, viewpointImages]);


  useEffect(() => {
    if (!isFilesLoaded) return;
    //If you don't pass additionalButtonsMaxSize that is matching a css setting, it won't size properly
    const buttonsMaxSize = productSettings.additionalButtonsMaxSize ? productSettings.additionalButtonsMaxSize : 200;
    //The reference buttons size for scaling is 200px
    setButtonsDivSize(Math.min((viewerSize.width - windowMargin), 1000 * buttonsMaxSize / 200) / (1000 * buttonsMaxSize / 200) * buttonsMaxSize);
  }, [viewerSize, isFilesLoaded, productSettings.additionalButtonsMaxSize]);

  useEffect(() => {
    console.log('buttons div size:', buttonsDivSize);
  }, [buttonsDivSize]);

  const userAgent = navigator.userAgent || window.opera;
  const isMobileDevice = /Mobi|Android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
    || (/android/i.test(userAgent));
  const verticalLayout = productSettings.orientation === 'vertical' && !isMobileDevice && windowWidth > mobileWidthThreshold;

  const maxAspectRatio = ((ratioTop, ratioProduct, ratio360) => {
    return isTopPresent ? Math.max(aspectRatioTop, isProductPresent ? aspectRatioProduct : 0, is360Present ? aspectRatio360 : 0) :
      isProductPresent ? Math.max(aspectRatioProduct, is360Present ? aspectRatio360 : 0) : is360Present ? aspectRatio360 : 1;
  })

  useEffect(() => {
    // Spinner options
    const spinnerOptions = {
      lines: 12, // The number of lines to draw
      length: 0, // The length of each line
      width: 5, // The line thickness
      radius: 10, // The radius of the inner circle
      scale: 4, // Scales overall size
      corners: 1, // Corner roundness (0..1)
      color: '#000', // CSS color or array of colors
      fadeColor: 'transparent', // CSS color or array of colors
      speed: 1, // Rounds per second
      rotate: 0, // The rotation offset
      animation: 'spinner-line-fade-quick', // The CSS animation name
      direction: 1, // 1: clockwise, -1: counterclockwise
      zIndex: 2e9, // The z-index (defaults to 2000000000)
      className: 'spinner', // CSS class to assign to the spinner
      top: '50%', // Top position relative to parent
      left: '50%', // Left position relative to parent
      shadow: '0 0 1px transparent', // Box-shadow for the lines
      position: 'absolute', // Element positioning
    };

    // Create a Spinner instance
    const spinner = new Spinner(spinnerOptions);
    spinnerInstanceRef.current = spinner;

    // Mount spinner to the container
    if (spinnerContainerRef.current) {
      spinner.spin(spinnerContainerRef.current);
    }

    // Cleanup on component unmount
    return () => {
      if (spinnerInstanceRef.current) {
        spinnerInstanceRef.current.stop();
      }
    };
  }, [spinnerContainerRef.current]);

  {/* TODO: Refactor code for better method than using bool */ }

  console.log('aspectRatioTop:', aspectRatioTop, 'aspectRatioProduct', aspectRatioProduct, '360:', aspectRatio360);
  console.log('window width:', window.innerWidth);
  console.log('margin:', productSettings.windowMargin);
  console.log('verticalLayout:', verticalLayout);
  console.log('product settings orientation:', productSettings.orientation);
  console.log('mainProductViewerHeight:', mainProductViewerHeight);
  console.log('PIC TO SHOW:', picToShow);
  console.log('viewer margin left:', viewerMarginLeft);

  console.log('is files loaded:', isFilesLoaded);
  console.log('variantFileGlb:', modelGlb);

  console.log('Product settings:', productSettings);
  console.log('isTopPresent:', isTopPresent);
  console.log('max aspect ratio:', maxAspectRatio(aspectRatioTop, aspectRatioProduct, aspectRatio360));
  console.log('Second param, viewer width:', Math.min((((viewerSize.width > mobileWidthThreshold) || viewerSize.width >= widthSwitchToFullScreen) ? viewerSize.width - windowMargin :
    Math.min(viewerSize.width - windowMargin, (widthSwitchToFullScreen - 1))),
    (maxViewerWidth)), viewerSize.width);

  //Force viewer to a certain value (e.g. 500px width) at startup, then set viewerSize
  //The aspect ratio might be changing, causing the product viewer to resize
  //Pb: buttonsDivSize isn't accurate as we don't use the whole width
  return (
    <>
      {/* <FPSCounter /> */}
      <div
        ref={mainProductViewerRef}
        className={`mainProductViewer ${verticalLayout ? 'verticalLayout' : ''}`}
        style={{
          // Note that window.visualViewport can be smaller than window.innerWidth on mobile
          width: Math.min(((viewerSize.width > mobileWidthThreshold) || viewerSize.width >= widthSwitchToFullScreen) ?
            viewerSize.width - windowMargin : Math.min(viewerSize.width - windowMargin, widthSwitchToFullScreen - 1), maxViewerWidth),
          height: (1 / (maxAspectRatio(aspectRatioTop, aspectRatioProduct, aspectRatio360)))
            * (Math.min((((viewerSize.width > mobileWidthThreshold) || viewerSize.width >= widthSwitchToFullScreen) ? viewerSize.width - windowMargin :
              Math.min(viewerSize.width - windowMargin, (widthSwitchToFullScreen - 1))),
              (maxViewerWidth)) - (verticalLayout ? calculatedButtonsDivSize + viewerMarginLeft + viewerMarginRight : 0)) + (verticalLayout ? 0 : calculatedButtonsDivSize + viewerMarginBottom),
          marginRight: viewerSize.width > mobileWidthThreshold || viewerSize.width >= widthSwitchToFullScreen ? viewerContainerMarginRight : 0,
          marginBottom: verticalLayout && (viewerSize.width > mobileWidthThreshold || viewerSize.width >= widthSwitchToFullScreen) ? 0 : viewerContainerMarginBottom,
          marginLeft: viewerSize.width > mobileWidthThreshold || viewerSize.width >= widthSwitchToFullScreen ? viewerContainerMarginLeft : 0,
        }}
      >
        <div 
          className="product-display-wrapper"
          style={{
            marginLeft: verticalLayout ? viewerMarginLeft : 0,
            marginRight: verticalLayout ? viewerMarginRight : 0,
            marginBottom: verticalLayout ? 0 : viewerMarginBottom,
            width: (verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight : mainProductViewerWidth),
            height: (verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom)
          }}
        >
          <div className="model-viewer-wrapper">
            {!isAspectRatio360Calculated || !isAspectRatioTopCalculated || !isAspectRatioProductCalculated ?
              null
              : (modelviewerSelected === SelectedViewer.ThreeD || isModelViewerLoaded) && (
                isFilesLoaded ? (
                  <>
                    {/* <div className="model-viewer-3D" style={{ marginBottom: '25px' }}> */}
                    <div
                      className="model-viewer-container"
                      style={{
                        marginLeft: verticalLayout ? viewerMarginLeft : 0,
                        marginRight: verticalLayout ? viewerMarginRight : 0,
                        marginBottom: verticalLayout ? 0 : viewerMarginBottom,
                        width: (verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight : mainProductViewerWidth),
                        height: (verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom)
                      }}
                    >
                      {/* TODO: add prop so we can set the camera angle */}
                      <Suspense fallback={<div>Loading...</div>}>
                        <ModelViewer
                          onSetLoading={props.onSetLoading}
                          variantFileGlb={modelGlb}
                          variantFileGlbUncompressed={modelGlbU}
                          variantFileUsd={modelUsd}
                          variantFilesHdr={modelHdrs}
                          variantEnvironmentsHdr={environmentHdrs}
                          //forceUpdate={forceUpdate}
                          yawAngle={yawAngle}
                          pitchAngle={pitchAngle}
                          windowWidth={window.innerWidth}
                          windowHeight={window.innerHeight}
                          aspectRatio={aspectRatio360}
                          objectDimensions={objectDimensions}
                          productTags={props.productTags}
                          modelType={props.modelType}
                          productSettings={productSettings}
                          configuratorEnabled={props.configuratorEnabled}
                          onMeshClicked={props.onMeshClicked}
                          setCamTransform={setCamTransform}
                          camTransform={camTransform}
                          viewerModeState={viewerMode}
                          // onViewerModeChange={changeViewerMode}
                          parentWidth={(verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight :
                            mainProductViewerWidth)}
                          parentHeight={(verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom)}
                          onTriggerAR={triggerAR}
                          onScreenshotsReady={handleScreenshotsReady}
                          modelviewerSelected={modelviewerSelected}
                        />
                      </Suspense>
                      {/* Pass on button click event */}
                      {/* <Carousel 
              onSetLoading={props.onSetLoading} 
              variantFileGlb={modelGlb} 
              variantFileUsd={modelUsd} 
              yawAngle={yawAngle} 
              pitchAngle={pitchAngle} 
              windowWidth={window.innerWidth}
              aspectRatio={aspectRatio360}
              parentWidth={productSettings.orientation === 'vertical' ? 0.8 * mainProductViewerWidth : mainProductViewerWidth} 
              parentHeight={productSettings.orientation === 'vertical' ? mainProductViewerHeight : 0.8 * mainProductViewerHeight}
              setTriggerAR={setTriggerAR}
              /> */}
                    </div>
                  </>) : (null)
              )
            }
          </div>
          <div className="images-wrapper" style={{zIndex: 20}}>
            {modelviewerSelected === SelectedViewer.ThreeD ?
              null :
              modelviewerSelected === SelectedViewer.ThreeSixty ? (
                isFilesLoaded && images360.length > 0 ? (
                  <div className={`viewer360 ${verticalLayout ? 'verticalLayout' : ''}`}
                    style={{
                      marginLeft: verticalLayout ? viewerMarginLeft : 0,
                      marginRight: verticalLayout ? viewerMarginRight : 0,
                      marginBottom: verticalLayout ? 0 : viewerMarginBottom,
                      width: (verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight : mainProductViewerWidth),
                      height: (verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom)
                    }}
                  >
                    <img
                      className={`icon-360-spin`}
                      src={`${window.ASSET_BASE_URL || process.env.PUBLIC_URL}/360spinicon.png`}
                      style={{
                        display: isShow360SpinIcon ? "block" : "none",
                        left: 0.46 * mainProductViewerWidth,
                        width: 0.1 * mainProductViewerWidth,
                        height: 0.1 * mainProductViewerWidth,
                      }}
                    ></img>
                    <Suspense fallback={<div>Loading...</div>}>
                      <ProductViewerComponent
                        // productsS3Bucketname={props.productS3BucketUrl}
                        // productFolder={props.productFolder}
                        // cloudFrontUrl={props.cloudFrontUrl}
                        autoplayViewer={isAutoPlay && props.isAutoPlay}
                        imageToShow={imageToShow}
                        forceUpdate={forceUpdate}
                        images360HD={images360HD}
                        images360={images360}
                        onClickZoom={(handleZoomClick)}
                        productSettings={productSettings}
                        windowWidth={window.innerWidth}
                        aspectRatio={aspectRatio360}
                        //Keep product viewer in the right aspect ratio
                        parentWidth={(verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight :
                          mainProductViewerWidth)}
                        parentHeight={(verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom)}
                        onPointerMoved={() => { setIsShow360SpinIcon(false); }}
                        showRotationIconOnStartup={productSettings.showRotationIconOnStartup}
                        imagesCount={productSettings.react360ImagesCount}
                        is180Pan={productSettings.is180Pan}
                      />
                    </Suspense>
                  </div>) :
                  (
                    <div className="viewer360Loader"
                      style={{
                        width: verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize : mainProductViewerWidth,
                        height: mainProductViewerHeight - calculatedButtonsDivSize,
                        position: 'relative',
                      }}>
                      {/* <div
                        ref={spinnerContainerRef}
                        style={{
                          width: verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize : mainProductViewerWidth,
                          height: mainProductViewerHeight - calculatedButtonsDivSize,
                        }}
                      ></div> */}
                      {/* <Player
              autoplay
              loop
              src={`${process.env.PUBLIC_URL}/lottie_loading_pill.json`}
              style={{ height: mainProductViewerWidth, width: mainProductViewerHeight }}
              /> */}
                    </div>)
              ) : (
                isFilesLoaded ? (
                  <>
                    <div
                      className={`growmProductImage ${verticalLayout ? 'verticalLayout' : ''}`}
                      style={{
                        width: (verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight : mainProductViewerWidth),
                        height: (verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom),
                        marginLeft: verticalLayout ? viewerMarginLeft : 0,
                        marginRight: verticalLayout ? viewerMarginRight : 0,
                        marginBottom: verticalLayout ? 0 : viewerMarginBottom,
                      }}
                    >
                      {picToShow && picToShow.includes('_top.jpg') ? (
                        <Suspense fallback={<div>Loading...</div>}>
                          <InnerImageZoom
                            src={picToShow}
                            // zoomSrc={currentHDImageUrl}
                            zoomType="click"
                            fullscreenOnMobile={true}
                            hasSpacer={true}
                            alt='Front'
                            width={(verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight : mainProductViewerWidth)}
                            height={(verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom)}
                          />
                        </Suspense>
                      ) : (
                        <img
                          className="iiz__img"
                          src={picToShow}
                          width={(verticalLayout ? mainProductViewerWidth - calculatedButtonsDivSize - viewerMarginLeft - viewerMarginRight : mainProductViewerWidth)}
                          height={(verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - calculatedButtonsDivSize - viewerMarginBottom)}
                        />
                      )}
                    </div>
                  </>
                ) : (null)
              )
            }
          </div>
        </div>
        <div className={`otherbuttonssection ${verticalLayout ? 'verticalLayout' : ''}`}>
          {isButtonsReady && showAdditionalButtons ? (
            isFilesLoaded ? (
              <Suspense fallback={<div>Loading...</div>}>
                <Preview
                  onPrevClick={handlePrev}
                  onNextClick={handleNext}
                  onChangeView={productSettings.pure3D ? changeCamView : change360View}
                  onSwitch3DViewer={switchViewer}
                  OnChangePicture={changePicToShow}
                  previewItems={modelGlb}
                  onHandlePreviewClick={handlePreviewClick}
                  viewpointImages={viewpointImages}
                  viewpointScreenshots3D={productScreenshots}
                  productImages={productImages}
                  currentIdx={currentIdx}
                  is180Pan={productSettings.is180Pan}
                  windowWidth={window.innerWidth}
                  productSettings={productSettings}
                  verticalLayout={verticalLayout}
                  parentWidth={verticalLayout ? mainProductViewerWidth - viewerMarginLeft - viewerMarginRight : mainProductViewerWidth}
                  parentHeight={verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - viewerMarginBottom}
                  buttonsDivSize={buttonsDivSize}
                  setCalculatedButtonsDivSize={setCalculatedButtonsDivSize}
                />
              </Suspense>
            ) : <></>
          ) : (null)
          }
        </div>
      </div>
       {/* <div><h1>Extra content here that takes a lot of room so that we need to scroll down a bit. That means
        we need to write a lot more until we reach the end of the page. That isn't enough yet so we need to carry on.
        Maybe soon it will be enough. We're nearly there. Just a little bit more. A bit more. And more.
        We carry on, almost there. Now that should do it</h1></div>  */}
    </>
  );
};

export default Main;